import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CheckboxInputComponent} from './checkbox-input.component';
import {FormsModule} from '@angular/forms';
import {TranslocoModule} from '@ngneat/transloco';
import {OptionButtonsModule} from '../../../shared/controls/option-buttons/option-buttons.module';
import {IneligibilityOverlayModule} from '@blocks/input/ineligibility-overlay/ineligibility-overlay.module';
import {SubmissionGizmoModule} from '@shared/submission-gizmo/submission-gizmo.module';
import {RequiredIndicatorComponent} from '@shared/controls/required-indicator/required-indicator.component';
import {ReadonlyIndicatorComponent} from '@shared/controls/readonly-indicator/readonly-indicator.component';

@NgModule({
  declarations: [
    CheckboxInputComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslocoModule,
    OptionButtonsModule,
    IneligibilityOverlayModule,
    SubmissionGizmoModule,
    RequiredIndicatorComponent,
    ReadonlyIndicatorComponent,
  ],
  exports: [
    CheckboxInputComponent,
  ]
})
export class CheckboxInputModule { }
